// extracted by mini-css-extract-plugin
export default {"container":"TextLink_container__Cqu22","text":"TextLink_text__IchHb","link":"TextLink_link__qUola"};